<template>
  <div class="modalForm">
    <transition name="bounce">
      <div class="commom-modal" v-if="visible">
        <div class="commom-modal-content">
          <div class="modal-header" @mousedown="modalDrag">
            {{ modalTitle }}
            <a @click="closeModal"><a-icon type="close" /></a>
          </div>
          <div class="modal-form">
            <a-spin :spinning="spin">
              <slot></slot>
            </a-spin>
          </div>
          <div class="modal-footer">
            <a-button type="default" @click="closeModal">取消</a-button>
            <a-button type="primary" @click="handleOk">确定</a-button>
          </div>
          <span class="modelset" @mousedown="modalDraw"></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Message } from "ant-design-vue";
export default {
  name: "modalForm",
  data() {
    return {
      form: [],
      sendFormList: {},
      imageUrl: "",
      imgData: {
        accept: "image/gif, image/jpeg, image/png, image/jpg",
      },
      imgName: {},
    };
  },
  props: [
    "modalTitle",
    "formList",
    "modalVisible",
    "formValue",
    "selectValue",
    "defaultFormVisible",
    "spinning",
  ],
  mounted() {
    for (let i in this.selectValue) {
      this.formList[i].data = this.selectValue[i] || "";
    }
  },
  computed: {
    visible() {
      return this.modalVisible;
    },
    formValues() {
      return this.formValue;
    },
    originData() {
      return this.formValue.originData;
    },
    defaultFormVisibles() {
      return this.defaultFormVisible !== undefined
        ? this.defaultFormVisible
        : true;
    },
    spin() {
      return this.spinning || false;
    },
  },
  methods: {
    setEmptySearchInfo(array) {
      for (let key in array) {
        let data = array[key];
        let value = data.value;
        if (data.tag == "switch") {
          value = false;
        }
        if (data.tag == "imgfile") {
          this.imgName = data.key;
          this.$set(data, "base64", "");
        }
        this.$set(data, data.key, value);
      }
      return array;
    },
    setFormValue(val) {
      for (let i in this.formList) {
        this.$set(this.formList[i], i, val[i]);
      }
    },
    setSelectValue(val) {
      for (let i in this.formList) {
        this.$set(this.formList[i], i, val[i]);
      }
    },
    handleChange(event) {
      //平台上传logo
      let targetName = event.srcElement.id;
      let img = event.target.files[0];
      if (img) {
        let type = img.type;
        let size = img.size;
        if (this.imgData.accept.indexOf(type) == -1) {
          Message.error("请选择我们支持的图片格式！");
          return false;
        }
        if (size > 3145728) {
          Message.error("请选择3M以内的图片！");
          return false;
        }
        let formData = new FormData();
        formData.append("file", img, img.name);
        let reader = new FileReader();
        reader.readAsDataURL(img);
        var _this = this;
        reader.onload = function () {
          _this.$set(_this.formList[targetName], "base64", this.result);
        };
        this.formList[targetName][targetName] = formData;
      }
    },
    getLogoPic(name) {
      document.querySelector(`#${name}`).click();
    },
    handleOk() {
      for (let key in this.formList) {
        let data = this.formList[key];
        this.sendFormList[data.key] =
          data[data.key] !== undefined ? data[data.key] : "";
      }
      this.$emit("handleOk", this.sendFormList);
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
    modalDraw(e) {
      this.$modalreset.modaldraw(e);
    },
    modalDrag(e) {
      this.$modalreset.modaldrag(e);
    },
  },
  watch: {
    modalVisible: function (val) {
      if (val) {
        this.$nextTick(() => {
          var modalBox = document.querySelector(".commom-modal");
          var windowWidth = window.innerWidth;
          modalBox.style.left = (windowWidth - 800) * 0.5 + "px";
        });
      }
    },
    formValues: function (val) {
      if (val.length === 0) {
        this.setEmptySearchInfo(this.formList);
      } else {
        this.setFormValue(val);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.bounce-enter-active {
  animation: bounce-in 0.15s;
}
.bounce-leave-active {
  animation: bounce-in 0.15s reverse;
}
@keyframes bounce-in {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.upload {
  width: 100px;
  height: 100px;
  cursor: pointer;
  color: #999;
  text-align: center;
  border: 1px dashed #d9d9d9;
  align-items: center;
  .pic {
    line-height: 100px;
    height: 100%;
    img {
      max-width: 100%;
      display: inline-block;
    }
  }
  i {
    margin-top: 25px;
    font-size: 28px;
  }
}
</style>
